import { render, staticRenderFns } from "./DockablePanel.vue?vue&type=template&id=d71f5c66"
import script from "./DockablePanel.vue?vue&type=script&lang=js"
export * from "./DockablePanel.vue?vue&type=script&lang=js"
import style0 from "./DockablePanel.vue?vue&type=style&index=0&id=d71f5c66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports